import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { getBlogPost } from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setPost(null);
    setError(false);
    getBlogPost(slug).then(setPost).catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <div className="pt-44 pb-40 max-w-3xl mx-auto px-6 text-center" data-testid="blog-post-error">
        <h1 className="font-display text-5xl uppercase tracking-tighter mb-6">404</h1>
        <p className="font-mono text-white/50 mb-8">This entry could not be found.</p>
        <Link to="/blog" className="font-mono text-xs tracking-[0.2em] uppercase border border-white/20 px-6 py-4 hover:bg-white hover:text-black transition-colors">Back to Journal</Link>
      </div>
    );
  }

  if (!post) {
    return <div className="pt-44 pb-40 max-w-3xl mx-auto px-6 font-mono text-white/40">Loading…</div>;
  }

  return (
    <article className="pt-32 md:pt-44" data-testid="blog-post-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <Link to="/blog" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase text-white/50 hover:text-white transition-colors mb-10" data-testid="blog-back">
          <ArrowLeft size={14} /> Journal
        </Link>
        <div className="flex items-center gap-3 font-mono text-[10px] tracking-[0.2em] uppercase text-white/40 mb-6">
          <span className="text-[color:var(--accent)]">{post.category}</span><span>/</span><span>{post.date}</span><span>/</span><span>{post.read}</span>
        </div>
        <h1 className="font-display text-4xl md:text-6xl uppercase tracking-tighter leading-[0.9] mb-8">{post.title}</h1>
        <p className="font-mono text-sm text-white/50 mb-12">By {post.author}</p>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-10 mb-14">
        <div className="aspect-[16/9] overflow-hidden border border-white/10">
          <img src={post.cover} alt={post.title} className="w-full h-full object-cover grayscale" />
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 md:px-10 pb-24 md:pb-40">
        {/(<\/?(p|h[1-6]|ul|ol|li|a|strong|b|em|i|br|div)\b)/i.test(post.body) ? (
          <div
            className="post-body font-mono text-base md:text-lg text-white/70 leading-relaxed"
            dangerouslySetInnerHTML={{ __html: post.body }}
          />
        ) : (
          <div className="space-y-7">
            {post.body.split("\n\n").map((para, i) => (
              <p key={i} className="font-mono text-base md:text-lg text-white/70 leading-relaxed">{para}</p>
            ))}
          </div>
        )}

        <div className="mt-20 pt-10 border-t border-white/10 flex items-center justify-between">
          <span className="font-mono text-xs tracking-[0.2em] uppercase text-white/40">Liinex Information Systems ®</span>
          <Link to="/contact" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase text-white/70 hover:text-[color:var(--accent)] transition-colors" data-testid="post-cta">
            Work with us <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
    </article>
  );
}
